<template>
	<v-row
		justify = "center"
		align 	= "center"
	>
		<v-col
			xl 	 = "12"
			lg 	 = "12"
			md 	 = "12"
			sm 	 = "12"
			xs 	 = "12"
			cols = "12"
		>
			<v-card
				outlined
			>
				<v-card-title
					class = "secondary pa-1 body-2 white--text justify-center"
				>
					
					<v-icon
						small
						:color  = "head.color"
						v-text = "head.icon" 
						class  	= "mx-1"
					></v-icon>

					<span
						v-text = "$ml.get(head.title)"
					></span>
				</v-card-title>
				<v-card-text>
					<v-tabs
				      dark
				      fixed-tabs
				      v-model 			= "tab"
				      background-color  = "primary"
				      height  			= "20"
				    >
				      <v-tab
				        v-for = "(item_tab, idx_tab) of info_options"
				        :key  = "idx_tab"
				        v-if  = "item_tab.enable"
				      >
				        {{ item_tab.text }}
				      </v-tab>
				    </v-tabs>
				    <v-tabs-items v-model = "tab">
					    <v-tab-item
					        v-for = "(item_tab_i, idx_tab_i) of info_options"
					        :key  = "idx_tab_i"
					    >
					    	<v-row
					    	>
						    	<template
						    		v-for = "(item_field, idx_field) of info_fields[item_tab_i.key]"		
					    			v-if = "item_tab_i.type == 'fields'"
						    	>
					    			<v-col
					    				xl   = "3"
					    				lg 	 = "3"
					    				md   = "4"
					    				sm 	 = "4"
					    				xs 	 = "12"
					    				cols = "12"
					    			>

						    			<v-card outlined 
											v-if 	= "item_field.type == 'switch'"
											class 	= "pa-0 pl-1 caption pb-1" 
											
										>
											<v-switch			
												dense						
												false-value
												hide-details
												class 			= "mt-1"			
												v-model 		= "info[item_tab_i.key][item_field.key]"						
												:label 			= "$ml.get(item_field.text)"
												:prepend-icon 	= "item_field.icon"												
											></v-switch>
												<!-- v-if="item_field.type == 'switch'"						 -->
												<!-- class="pt-0" -->
										</v-card>
					    			</v-col>	
						    	</template>
						    	<v-col
					    			v-show = "item_tab_i.type == 'component'"

						    	>
						    		<component 
										:is		= "item_tab_i.component"
									></component>
						    	</v-col>
					    	</v-row>
					    	
					    </v-tab-item>
					</v-tabs-items>
				</v-card-text>		
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn
						x-small
						color  = "primary"
						v-text = "$ml.get('save')"
						@click = "save"
					></v-btn>
				</v-card-actions>	
			</v-card>
		</v-col>
	</v-row>
</template>
<script>

	import EventBus  from '@/event-bus'
	import technical from '@/components/general_parameters/technical_records.vue'

	export default{
		name : 'support',
		components : {
			technical
		}, // components
		data : () => ({
			info 		: {
				help 		  : {},
				notifications : {
					notifications_technical : true,
				},
			},
			info_item 	: {},
			tab 		: null,
			head 		: {
				title : 'support',
				color : 'primary',
				icon  : 'mdi-handshake',
			},
			info_fields : {


				help :[
				
					{
						key 		: 'report_issue',
						text 		: 'report_issue',
						type 		: 'modal',
						enable 		: false,
					}

				],
				notifications : [
					{
						key 		: 'notifications_technical',
						text 		: 'notifications_technical',
						type 		: 'switch',
						default 	: false,					
						enable 		: true,					
					},
				],

			},
			info_options : [
				{
					key 		: 'notifications',
					text 		: 'notifications',
					type 		: 'fields',
					enable 		: true,
					
				},
				/*{
		

					text 		: 'help',
					type 		: 'fields',
					enable 		: true,

				},*/
				{
					text 		: 'records',
					type 		: 'component',
					component 	: 'technical',
					enable 		: true,

				},
				/*{
					key 		: '',
					text 		: 'commands',
					type 		: 'btn',
					
				}, */
			],

		}), // data

		created(){
			this.get_list();

		}, // created

		methods : {

			save(){
				let obj  	= this.info_options[this.tab].key;				
				if (this.info){
					// const api = this.$URL + "/";
					let info_up = this.info;
					const valid = this.$Helper.set_local('setting_support', info_up);
					if (valid) {
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'saved',
							message : obj
						});
						this.$EventBus.$emit('update_support', info_up);
					}
				}else{
					console.log("Not info to save");
				}
			}, // save

			get_list(){
				let temp_sup = this.$Helper.get_local('setting_support');
				if (temp_sup) {
					this.info = temp_sup;
				}
			}, // get list
		}, // methods
	};
</script>